<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <div
      class="flex-grow-1"
      :class="{ backgroundClass, 'py-3': padAppContent }"
      role="main"
    >
      <router-view />
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader.vue";
import TheFooter from "@/components/core/TheFooter.vue";
import TheNavbar from "@/components/core/TheNavbar.vue";

// API for performing CRUD operations from the Datastore
import DatastoreAPI from "@/helpers/DatastoreAPI";

import { mapState, mapGetters, mapActions } from "vuex";

import config from "@/data/config";

export default {
  name: "App",
  mixins: [DatastoreAPI],
  components: {
    TheHeader,
    TheNavbar,
    TheFooter
  },
  data() {
    return {
      backgroundClass: config.appStyle.backgroundClass,
      padAppContent: config.appStyle.padAppContent,
      entriesPollInterval: null,
      initialDataFetched: false
    };
  },
  computed: {
    ...mapState("datastore", ["entry", "entryLoaded", "entries"]),
    ...mapGetters(["mapToDatastore", "getToken", "useAuth"])
  },
  methods: {
    ...mapActions(["mapFromDatastore", "mapEntriesFromDatastore"])
  },
  watch: {
    /* Each time the route path changes (not query params), read from the datastore */
    "$route.path": {
      handler() {
        this.readEntry();
        this.readEntries();
      }
    },
    /* Fetch data once token is available (for auth-enabled apps) */
    getToken: {
      handler(newToken) {
        // If auth is enabled and token is now available, fetch data
        if (this.useAuth && newToken && !this.initialDataFetched) {
          this.readEntry();
          this.readEntries();
          this.initialDataFetched = true;
        }
      },
      // immediate: true means that the handler will be called immediately when the component is mounted
      immediate: true
    },
    entry() {
      /* When Vuex datastore/entry updates,
      map to Vuex App State */
      this.mapFromDatastore(this.entry);
    },
    entries: {
      deep: true,
      handler(newEntries, oldEntries) {
        const areEntriesEqual = (newEntries, oldEntries) => {
          return newEntries.every((newEntry, index) => {
            return (
              newEntry.onid === oldEntries[index]?.onid &&
              newEntry.tsUpdated === oldEntries[index]?.tsUpdated
            );
          });
        };

        // Enrich all islands when entries are updated
        if (
          newEntries &&
          Array.isArray(newEntries) &&
          !areEntriesEqual(newEntries, oldEntries)
        ) {
          this.mapEntriesFromDatastore(newEntries);
        }
      }
    },
    entryLoaded() {
      /* When Vuex datastore/entryLoaded updates,
      here is an opportunity to initial */
      if (this.entry === "") {
        // call vuex actions to set your initial state, then call....
        // this.setSomething(value);
        this.updateEntry(this.mapToDatastore);
      }
    }
  },
  mounted() {
    // Poll readEntries every minute to keep data up to date
    this.entriesPollInterval = setInterval(() => {
      console.log("polling for entries");
      this.readEntries();
    }, 60000); // 60000ms = 1 minute
  },
  beforeUnmount() {
    // Clear the polling interval when component is destroyed
    if (this.entriesPollInterval) {
      clearInterval(this.entriesPollInterval);
      this.entriesPollInterval = null;
    }
  }
};
</script>
